/* eslint-disable react/forbid-component-props */
import { productCardContainerSX } from '@/components/blocks/DpLibrary/DpProductCard/styles/container';
import { productCardImagerSX } from '@/components/blocks/DpLibrary/DpProductCard/styles/image';
import {
	productCardCategorySX,
	productCardDescriptionSX,
	productCardDiscountSX,
	productCardPriceSX,
	productCardTitleSX,
} from '@/components/blocks/DpLibrary/DpProductCard/styles/typography';
import { Img } from '@/components/blocks/MaterialImage';
import { RenderProductImg } from '@/components/blocks/RenderProductImg';
import { ProductRibbons } from '@/components/blocks/Ribbons';
import { Ribbon } from '@/data/types/Product';
import { mergeRibbonsForProduct } from '@/utils/mergeRibbonsForProduct';
import { Box, Grid, Typography } from '@mui/material';
import Link from 'next/link';

type ProductType = 'electronic' | '';

export const DpProductCard = ({
	title,
	category,
	image,
	discount,
	price,
	type,
	seo,
	ribbons = [],
}: {
	title: string;
	category: string;
	image: string;
	discount?: string;
	price: string;
	colors?: string[];
	type?: ProductType;
	seo?: string;
	ribbons?: Ribbon[];
}) => {
	const sxPrice = productCardPriceSX(discount !== undefined);

	const sortedRibbons = mergeRibbonsForProduct(ribbons);

	return (
		<Grid className="product-card-container" sx={productCardContainerSX}>
			<Link className="product-card-linkable" href={`${seo}`} draggable={false}>
				<Box className="product-card-frame" sx={{ position: 'relative' }}>
					<RenderProductImg
						fullImageRaw={image}
						render={(image) => (
							<Img
								className="product-card-image"
								src={image}
								draggable={false}
								alt={title}
								sx={productCardImagerSX}
							/>
						)}
					/>
					<ProductRibbons ribbons={sortedRibbons} />
				</Box>
			</Link>
			<Grid
				padding={type === 'electronic' ? '0 10px 10px 10px' : '10px 15px 5px 15px'}
				marginTop={type === 'electronic' ? '' : '-5px'}
			>
				{type === 'electronic' ? (
					<>
						<Typography sx={productCardTitleSX}>{title}</Typography>
						<Typography sx={productCardDescriptionSX}>{'Con dpvale desde:'}</Typography>
						<Typography sx={productCardDiscountSX}>{'$871 quincenal'}</Typography>
						<Typography sx={productCardDescriptionSX}>
							{'$14,899 en 14 quincenas* De contado: $14,899'}
						</Typography>
					</>
				) : (
					<Grid
						container
						display={'flex'}
						flexDirection={'column'}
						justifyContent={'space-between'}
						height={'134px'}
					>
						<Box>
							<Grid item sx={{ mb: '4px', maxHeight: '46px', height: '46px' }}>
								<Typography sx={productCardTitleSX}>{title}</Typography>
							</Grid>
							<Grid item sx={{ mb: '11px' }}>
								<Typography sx={productCardCategorySX}>{category}</Typography>
							</Grid>
							<Grid
								item
								sx={{
									display: 'flex',
									flexDirection: 'row',
								}}
							>
								{discount ? <Typography sx={productCardDiscountSX}>{discount}</Typography> : null}
								<Typography sx={sxPrice}>{price}</Typography>
							</Grid>
						</Box>
					</Grid>
				)}
			</Grid>
		</Grid>
	);
};
